import AddSubOrgDialog from 'views/org/SubOrgs/components/AddSubOrgDialog';
import React, { useMemo, useState } from 'react';
import { useGetOrgQuery, useGetOrgsQuery } from 'store/slices/apiV1/org';
import ExtendedDatagrid from 'ui-component/DataGrid/ExtendedDatagrid';
import { DatagridNames } from 'types/datagrid';
import { skipToken } from '@reduxjs/toolkit/dist/query/react';
import { useSelector } from 'store';
import _ from 'lodash';
import { columns } from 'views/org/SubOrgs/columns';
import { ALL_APPS, ALL_FEATURE_IDS } from 'constants/appConstants';
import { appPermissionAccessLevels } from 'types/apps';
import { Org } from 'types/org';
import { SubOrgGenerateReportData } from 'types/generateReports';
import MainCard from 'ui-component/cards/MainCard';

const SubOrgs = () => {
  const [addSubOrgDialogOpen, setAddSubOrgDialogOpen] = useState(false);
  const { activeOrgId } = useSelector((state) => state.org);

  const { data: orgs = [], isLoading: isLoadingOrgs } = useGetOrgsQuery();
  const { data: org } = useGetOrgQuery(activeOrgId ?? skipToken);

  const memoizedRows = useMemo(
    () => _.filter(orgs, (o) => o?.createdFrom === activeOrgId),
    [orgs, activeOrgId]
  );

  return (
    <>
      <MainCard>
        <ExtendedDatagrid<Org, SubOrgGenerateReportData>
          loading={isLoadingOrgs}
          exportFileNamePrefix={`${org?.name?.replaceAll(' ', '_')}_suborgs`}
          noRows="Click Add Sub Org to add a sub org to your organization."
          gridName={DatagridNames.subOrgs}
          rows={memoizedRows}
          columns={columns}
          generateReportData={{
            orgs: memoizedRows,
          }}
          newRecordButton={{
            label: 'Add Sub Org',
            permissionScope: {
              app: ALL_APPS.ORG_SETTINGS.id,
              accessLevel: appPermissionAccessLevels.edit,
              feature: ALL_FEATURE_IDS.SUB_ORGS,
            },
            onClick: () => {
              setAddSubOrgDialogOpen(true);
            },
          }}
        />
      </MainCard>
      <AddSubOrgDialog
        dialogOpen={addSubOrgDialogOpen}
        onClose={() => setAddSubOrgDialogOpen(false)}
      />
    </>
  );
};

export default SubOrgs;
